import { Component, OnInit, Input, HostListener } from '@angular/core';
import * as d3 from 'd3';
@Component({
    selector: 'app-100bar-chart',
    templateUrl: './100-bar-chart.component.html'
})
export class HundredPercentBarChartComponent implements OnInit {
    @Input() GraphData: any;
    viewData = [];
    barnumber = 4;
    currentPage = 1;
    totalPage: number;
    zero_count = 0;
    constructor() { }
    ngOnInit(): void {
    }
    ngAfterViewInit() {
        this.Load100PercBarChart(this.GraphData.chartData, this.GraphData.chartContainerName)
    }
    Load100PercBarChart(lineData, chartContainer) {
        let that = this;
        let containerId = chartContainer;
        this.totalPage = Math.ceil(lineData.length / this.barnumber);
        this.viewData = lineData.slice((this.currentPage - 1) * this.barnumber, this.currentPage * this.barnumber);
        let containerIdwithoutHash = containerId.split('#')[1];
        let divId = '#div_' + containerIdwithoutHash;
        d3.select(chartContainer).html("");
        d3.select(containerId).append("div").attr('id', 'div_' + containerIdwithoutHash);
        d3.select(divId).classed('100Bar', true);

        const yscale_bw = 24;
        const rx = yscale_bw / 2, ry = yscale_bw / 2;

        //Finding total number of tickets to calculate the percentage
        var totalTickets = 0;
        lineData.forEach(function (item) {
            totalTickets += item.sankeyData;
        });
        if(totalTickets == 0)
        {
            totalTickets = 1;
            this.zero_count = 1;
        }
        let barWidth = 30;
        let scrollBar = false;
        let divWidth = d3.select(chartContainer).node().offsetWidth - 50;
        // set the dimensions and margins of the graph
        var svgWidth = d3.select(chartContainer).node().offsetWidth;
        //if (svgHeight > 350) {
        //    scrollBar = true;
        //    svgWidth = svgWidth - 70;
        //}
        //else {
        //    svgHeight = 350;
        //}
        var svgHeight = 350;
        var margin = { top: 20, right: 30, bottom: 50, left: 90 };
        var width = svgWidth - margin.left - margin.right;
        var height = svgHeight - margin.top - margin.bottom;
        //  d3.select(divId).style("max-height", 350 + "px").style("max-width", divWidth + "px").style("overflow-x", "auto").style("overflow-y", "auto");

        //Adding SVG element inside Container
        //var svg = d3.select(chartContainer).append("div")
        //    .classed("svg-container", true) //container class to make it responsive
        //    .append("svg")
        //    //responsive SVG needs these 2 attributes and no width and height attr
        //    .attr("preserveAspectRatio", "xMinYMin meet")
        //    .attr("viewBox", "0 0 " + svgWidth + " " + svgHeight)
        //    //class to make it responsive
        //    .classed("svg-content-responsive", true); 

        var svg = d3.select(divId).append("svg").attr('id', 'svg_' + containerIdwithoutHash);
        //if (!scrollBar) {
        //    svg.attr("preserveAspectRatio", "xMinYMin meet")
        //        .attr("viewBox", "0 0 " + svgWidth + " " + svgHeight);
        //}
        //else {
        svg
            .attr('width', svgWidth)
            .attr('height', svgHeight);
        // }
        svg.append("defs").append("clipPath")
            .attr("id", containerIdwithoutHash + "_clip")
            .append("rect")
            .attr("width", width)
            .attr("height", height);
        //Create group element inside svg element to draw chart
        const chart = svg.append('g')
            .attr("transform",
                "translate(" + margin.left + "," + margin.top + ")"
            );

        var yScale = d3.scaleBand().range([0, height]).domain(this.viewData.map((d) => d.sankeyXData)).padding(0.36);

        let yAxis = chart.append('g').attr("class", "yaxis").call(d3.axisLeft(yScale)
            .tickSize(9)
            .tickPadding(5))
        //.select('.yaxis path').style('opacity', 1);
        yAxis
            .selectAll('line')
            .attr('stroke', '#e6e6e6')
        yAxis
            .select('.domain')
            .style('opacity', 0);
        chart.selectAll('.yaxis .tick text')
            .text(d => {
                if (d.length > 9) {
                    d = d.substring(0, 6) + '...';
                }
                return d;
            })
            .append('title')
            //.text(d => d.length >= 15 ? d : null);
            .text(d => d);
        var xScale = d3.scaleLinear().range([0, width]).domain([0, 100]);

        let xAxis = chart.append('g')
            .attr('transform', `translate(0, ${height})`)
            .attr("class", "xaxis")
            .call(d3.axisBottom(xScale)
                .tickFormat((d) => d + '%')
                .tickPadding(10)
                .tickSize(-height))
        //.select('.xaxis path').style('opacity', 0);
        xAxis
            .selectAll('line')
            .attr('stroke', '#e6e6e6')
        xAxis
            .select('.domain')
            .style('opacity', 0);
        //Add text overflow property for x axis labels
        //d3.select(chartContainer).selectAll('.yaxis text')
        //    .attr('title', function (d) { d3.select(this).text })
        //    .style('text-overflow', 'ellipsis')
        //    .style('white-space','nowrap');

        // //Tooltip
        // var tooltip = d3.select(chartContainer)
        //     .append("div")
        //     .attr("class", "tooltip")
        //     .style("opacity", 0);

        //Drawing 100% bar chart
        var bargroups = chart
            .append('g')
            .attr("clip-path", "url(#" + containerIdwithoutHash + "_clip)")
            .selectAll()
            .data(this.viewData)
            .enter()
            .append('g');
        if(this.zero_count==1){
            var bars = bargroups
            .append('rect')
            //.attr('y', function (s) { return yScale(s.sankeyXData) + (yScale.bandwidth() / 2) - (barWidth / 2); })
            .attr('x', 0)
            .attr('y', (g) => (yScale(g.sankeyXData) - 2 * rx) + yScale.bandwidth() / 2 + ry)
            .attr('height', yscale_bw)
            //.attr('height', barWidth)
            .attr('width', (g) => xScale(0.3))
            // .attr('width', (g) => xScale((g.sankeyData/totalTickets)*100))
            .attr("class", "100% bar")
            .attr('fill', '#A260B7');
        }
        else{
        var bars = bargroups
            .append('rect')
            //.attr('y', function (s) { return yScale(s.sankeyXData) + (yScale.bandwidth() / 2) - (barWidth / 2); })
            .attr('x', 0)
            .attr('y', (g) => (yScale(g.sankeyXData) - 2 * rx) + yScale.bandwidth() / 2 + ry)
            .attr('height', yscale_bw)
            //.attr('height', barWidth)
            // .attr('width', (g) => xScale(0.3))
            .attr('width', (g) => xScale((g.sankeyData/totalTickets)*100))
            .attr("class", "100% bar")
            .attr('fill', '#A260B7');
        }
        var roundedCorners = bargroups
            .append('path')
            .attr('class', 'bar')
            .attr("d", d => {
                if (d.sankeyData > 0) {
                    return `
                M${(xScale((d.sankeyData/totalTickets)*100))-15},${yScale(d.sankeyXData) + yScale.bandwidth() / 2}
                a${rx},${ry} 0 1 0 ${rx},${-ry}
                h${yscale_bw - 2 * rx}
                a${rx},${ry} 0 1 0 ${rx},${ry}                 
                h${-(yscale_bw)}Z`
                }
                else {
                    return "";
                }
            })
            .attr('fill', '#A260B7');
        roundedCorners
            .on('mouseover', function (d, i) {
                //console.log(d);
                //console.log(d3.select(this.parentNode).datum().key)
                d3.select(this).style("fill", "#A260B7");
                d3.select(this).style('cursor', 'pointer');
                var tooltip = svg
                    .append("g")
                    .style("cursor", "pointer")
                    .attr("class", "tooltip")
                    .style("opacity", 1)
                tooltip.append("rect")
                    .attr("width", 90)
                    .attr('height', 40)
                    .style('fill', '#FFFFFF')
                    .style('pointer-events', 'none')
                    .style('stroke', d3.select(this).style('fill'))
                    .style('stroke-width', 2)
                    .style('fill-opacity', 0.8);
                var textSvg = tooltip.append("text")
                    .attr('x', 7)
                    .attr('y', 15)
                    .style('pointer-events', 'none')
                    .style('fill', '#333333')
                    .style('font-size', '12px')
                    .style('color', '#333333');
                textSvg.append("tspan")
                    .style('font-size', '11px')
                    .style('pointer-events', 'none')
                    .style("font-family", "Graphik Medium")
                    .style('font-weight', 'bold')
                    .text(d3.select(this).data()[0].sankeyXData)
                textSvg.append("tspan")
                    .attr('x', 7)
                    .attr('dy', 15)
                    .style('pointer-events', 'none')
                    .style('fill', d3.select(this).style('fill'))
                    .html('&#x25cf') //&#9679; //&bull;
                textSvg.append("tspan")
                    .attr('dx', 0)
                    .style('pointer-events', 'none')
                    .style('font-size', '11px')
                    .style("font-family", "Graphik Medium")
                    .style('font-weight', 'bold')
                    .text(that.viewData[0].XAxis + ": ")
                    .style('font-weight', 'bold')
                textSvg.append("tspan")
                    .attr('dx', 0)
                    .style('pointer-events', 'none')
                    .style("font-family", "Graphik Medium")
                    .style('font-weight', 'bold')
                    .text(d3.format(',')(parseInt(d3.select(this).data()[0].sankeyData)) + ' (' + ((parseInt(d3.select(this).data()[0].sankeyData) / totalTickets) * 100).toFixed(0) + '%)');
                // //show tooltip
                // tooltip.transition().duration(50).style('opacity', 0.9);
                // tooltip.html(d3.select(this).data()[0].sankeyXData + '<br> #' + lineData[0].XAxis + ' : ' + parseInt(d3.select(this).data()[0].sankeyData))
                //     .style('left', (d3.event.offsetX - 55) + 'px')
                //     .style('top', (d3.event.offsetY - 20) + 'px')
                //     .style("display", "block");
            })
            .on("mousemove", function (d, i) {
                //d3.select(this).style('opacity', 1)
                d3.select(this).style("fill", "#A260B7");
                d3.select(this).style('cursor', 'pointer');
                var mousePosition = d3.mouse(this);
                var x = mousePosition[0];// + width / 2;
                var y = mousePosition[1];// + height / 2;
                var text = d3.select(this.closest('svg')).select('.tooltip text');
                //svg.selectAll('.tooltip text tspan').nodes().forEach(element => {
                //    console.log(element.getBBox().width);
                //})
                var bbox = text.node().getBBox();
                d3.select(this.closest('svg'))
                    .select('.tooltip rect')
                    .attr("width", bbox.width + 15)
                if (x - bbox.width / 2 < 0) {
                    x = bbox.width / 2;
                }
                else if (width - x - bbox.width / 2 < 0) {
                    x = width - bbox.width / 2;
                }
                if (y - bbox.height / 2 < 0) {
                    y = bbox.height * 2;
                }
                else if (height - y - bbox.height / 2 < 0) {
                    y = height - bbox.height / 2;
                }
                d3.select(this.closest('svg'))
                    .select('.tooltip')
                    .style("opacity", 1)
                    .attr('transform', `translate(${x + 10}, ${y - 20})`);
            })
            .on("mouseout", function (d, i) {
                d3.select(this).style("fill", "#A260B7");
                d3.select(this.closest('svg'))
                    .select('.tooltip').style('display', 'none');
                d3.select(this.closest('svg'))
                    .select(".tooltip").remove();
                d3.select(this)//.selectAll('path')
                    .style("opacity", 1);
            });
        bars.on('mouseover', function (d, i) {
            //console.log(d);
            //console.log(d3.select(this.parentNode).datum().key)
            d3.select(this).style("fill", "#A260B7");
            d3.select(this).style('cursor', 'pointer');
            var tooltip = svg
                .append("g")
                .style("cursor", "pointer")
                .attr("class", "tooltip")
                .style("opacity", 1)
            tooltip.append("rect")
                .attr("width", 90)
                .attr('height', 40)
                .style('fill', '#FFFFFF')
                .style('pointer-events', 'none')
                .style('stroke', d3.select(this).style('fill'))
                .style('stroke-width', 2)
                .style('fill-opacity', 0.8);
            var textSvg = tooltip.append("text")
                .attr('x', 7)
                .attr('y', 15)
                .style('pointer-events', 'none')
                .style('fill', '#333333')
                .style('font-size', '12px')
                .style('color', '#333333');
            textSvg.append("tspan")
                .style('font-size', '11px')
                .style('pointer-events', 'none')
                .style("font-family", "Graphik Medium")
                .style('font-weight', 'bold')
                .text(d3.select(this).data()[0].sankeyXData)
            textSvg.append("tspan")
                .attr('x', 7)
                .attr('dy', 15)
                .style('pointer-events', 'none')
                .style('fill', d3.select(this).style('fill'))
                .html('&#x25cf') //&#9679; //&bull;
            textSvg.append("tspan")
                .attr('dx', 0)
                .style('pointer-events', 'none')
                .style('font-size', '11px')
                .style("font-family", "Graphik Medium")
                .style('font-weight', 'bold')
                .text(that.viewData[0].XAxis + ": ")
                .style('font-weight', 'bold')
            textSvg.append("tspan")
                .attr('dx', 0)
                .style('pointer-events', 'none')
                .style("font-family", "Graphik Medium")
                .style('font-weight', 'bold')
                .text(d3.format(',')(parseInt(d3.select(this).data()[0].sankeyData)) + ' (' + ((parseInt(d3.select(this).data()[0].sankeyData) / totalTickets) * 100).toFixed(0) + '%)');
            // //show tooltip
            // tooltip.transition().duration(50).style('opacity', 0.9);
            // tooltip.html(d3.select(this).data()[0].sankeyXData + '<br> #' + lineData[0].XAxis + ' : ' + parseInt(d3.select(this).data()[0].sankeyData))
            //     .style('left', (d3.event.offsetX - 55) + 'px')
            //     .style('top', (d3.event.offsetY - 20) + 'px')
            //     .style("display", "block");
        })
            .on("mousemove", function (d, i) {
                //d3.select(this).style('opacity', 1)
                d3.select(this).style("fill", "#A260B7");
                d3.select(this).style('cursor', 'pointer');
                var mousePosition = d3.mouse(this);
                var x = mousePosition[0];// + width / 2;
                var y = mousePosition[1];// + height / 2;
                var text = d3.select(this.closest('svg')).select('.tooltip text');
                //svg.selectAll('.tooltip text tspan').nodes().forEach(element => {
                //    console.log(element.getBBox().width);
                //})
                var bbox = text.node().getBBox();
                d3.select(this.closest('svg'))
                    .select('.tooltip rect')
                    .attr("width", bbox.width + 15)
                if (x - bbox.width / 2 < 0) {
                    x = bbox.width / 2;
                }
                else if (width - x - bbox.width / 2 < 0) {
                    x = width - bbox.width / 2;
                }
                if (y - bbox.height / 2 < 0) {
                    y = bbox.height * 2;
                }
                else if (height - y - bbox.height / 2 < 0) {
                    y = height - bbox.height / 2;
                }
                d3.select(this.closest('svg'))
                    .select('.tooltip')
                    .style("opacity", 1)
                    .attr('transform', `translate(${x + 10}, ${y - 20})`);
            })
            .on("mouseout", function (d, i) {
                d3.select(this).style("fill", "#A260B7");
                d3.select(this.closest('svg'))
                    .select('.tooltip').style('display', 'none');
                d3.select(this.closest('svg'))
                    .select(".tooltip").remove();
                d3.select(this)//.selectAll('path')
                    .style("opacity", 1);
            });
        chart
            .append('g')
            .selectAll()
            .data(this.viewData)
            .enter()
            .append('text')
            .attr('y', function (s) { return yScale(s.sankeyXData) + (yScale.bandwidth() / 2) + 2; })
            .attr("x", width + 5)//(d, i) => xScale(d[0]) + (xScale(d[1]) - xScale(d[0])) / 2)
            // .attr('height', yScale.bandwidth())
            .attr('height', barWidth)
            .attr('width', width)
            .attr("font-size", "8px")
            .style("fill", "black")
            .attr("font-family", "Graphik SemiBold")
            .text(d => {
                return that.CleanNumber(d.sankeyData);
            })

        //Bar chart Transition 
        //chart.select('.bar').transition()
        //    .duration(750)
        //    .attr("x", 0)
        //    .attr("y", function (s) { return yScale(s.sankeyXData); })
        //    .attr('height', yScale.bandwidth())
        //    .attr('width', function (s) { return xScale(s.sankeyData); });

        //y axis legend
        // svg.append('text')
        //     .attr('x', (svgWidth / 2))
        //     .attr('y', svgHeight - (margin.bottom / 2))
        //     .style('fill', '#015b63')
        //     .style('font-size', '12px')
        //     .style('font-weight', 'bold')
        //     .attr('text-anchor', 'Start')
        //     .text(this.viewData[0].XAxis + (this.viewData[0].XAxis == "TicketAge" ? " (In days - %)" : " (%)"));
        //Y Axis legend
        svg.append('text')
            .attr('x', -(height / 2))
            //.attr('y', (margin.left / 3))
            .attr('y', 10)
            .attr("dy", "1em")
            .attr("font-family", "Graphik Regular")
            .attr('transform', 'rotate(-90)')
            .style('fill', '#015b63')
            .style('font-size', '12px')
            .style('font-weight', 'bold')
            .attr('text-anchor', 'middle')
            .text(this.viewData[0].XAxis + (this.viewData[0].XAxis == "TicketAge" ? " (In days - %)" : " (%)"));
        //X Axis legend
        // svg.append('text')
        //     .attr('id', 'text_' + chartContainer)
        //     .style('display', 'block')
        //     .text(this.viewData[0].XAxis + ' (%)');
        // var textwidth = d3.select('#text_\\' + chartContainer).node().getBBox().width;
        // d3.select('#text_\\' + chartContainer).style('display', 'none')
        // svg.append("rect")
        //     .attr('x', (svgWidth / 2 - textwidth / 2) - 20 + 60)
        //     .attr('y', height + (margin.bottom / 2) + 15 + 15)
        //     .attr('height', 12)
        //     .attr('width', 12)
        //     .attr('rx', 6)
        //     .attr('ry', 6)
        //     .style('fill', '#A260B7')
        //     .style('cursor', 'default')
        //     .style('top', margin.top)
        //     .attr('text-anchor', 'end');


        // svg.append('text')
        //     .attr('x', (svgWidth / 2 - textwidth / 2 + 60))
        //     .attr('y', height + (margin.bottom / 2) + 25 + 15)
        //     .style('fill', '#015b63')
        //     .style('cursor', 'pointer')
        //     .style('font-size', '12px')
        //     .style('font-weight', 'bold')
        //     .attr('text-anchor', 'start')
        //     .text(this.viewData[0].XAxis + (this.viewData[0].XAxis == "TicketAge" ? " (In days - %)" : " (%)"));

        //Pagination
        svg.append("path")
            .attr("d", "M3.875,3.095,6.8.163a.551.551,0,0,1,.782,0,.558.558,0,0,1,0,.784L4.267,4.269a.553.553,0,0,1-.763.016L.161.949A.554.554,0,0,1,.943.165Z")
            .attr('transform', "translate(" + (margin.left - 15) + ", " + 25 + ") rotate(180)")
            .attr('class', 'leftTriangle')
            .attr('fill', '#000')
            .attr('stroke', '#000')
            .attr('stroke-width', 2)
            .attr("opacity", 0.7)
            .attr('cursor', 'pointer')
            .on('click', function (d) {
                if (that.currentPage != 1) {
                    that.currentPage--;
                    that.prevPage();
                }
            })
        svg.append("path")
            .attr("d", "M3.875,1.335,6.8,4.267a.551.551,0,0,0,.782,0,.558.558,0,0,0,0-.784L4.267.161A.553.553,0,0,0,3.5.145L.161,3.481a.554.554,0,0,0,.782.784Z")
            .attr('transform', "translate(" + (margin.left - 15) + ", " + (svgHeight - margin.bottom + 5) + ") rotate(180)")
            .attr('class', 'rightTriangle')
            .attr('fill', '#000')
            .attr('stroke', '#000')
            .attr('stroke-width', 2)
            .attr("opacity", 0.7)
            .style('cursor', 'pointer')
            .on('click', function (d) {
                if (that.currentPage < that.totalPage) {
                    that.currentPage++;
                    that.nextPage();
                }
            })

        if (that.currentPage == 1) {
            svg.select(".leftTriangle").attr('fill', '#cccccc').attr('stroke', '#cccccc').attr('stroke-width', 2).attr("opacity", 0.7).style('cursor', 'default');
        }
        if (that.currentPage == that.totalPage) {
            svg.select(".rightTriangle").attr('fill', '#cccccc').attr('stroke', '#cccccc').attr('stroke-width', 2).attr("opacity", 0.7).style('cursor', 'default');
        }
    }
    /*generic way */
    nextPage() {
        this.Load100PercBarChart(this.GraphData.chartData, this.GraphData.chartContainerName);
    }

    prevPage() {
        this.Load100PercBarChart(this.GraphData.chartData, this.GraphData.chartContainerName);
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.Load100PercBarChart(this.GraphData.chartData, this.GraphData.chartContainerName);
    }
    isNumeric(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }
    CleanNumber(str) {
        if(str != 0)
            str = str.toFixed(2);
        if (str >= 1)
            str = d3.format("~s")(str);
        else
            str = str;
        if (!this.isNumeric(str)) {
            let lastLetter = str.substring(str.length - 1);
            str = str.substring(0, str.length - 1);
            if (str.indexOf('.'))
                str = parseFloat(str).toFixed(1).toString() + lastLetter;
        }
        return str;
    }
}
